import { gql } from '@apollo/client';

export const UPSERT_INPUT = gql`
  mutation upsertInput($input: UpsertInputInput!) {
    inputs: upsertInput(input: $input) {
      id
      description
    }
  }
`;
